<template>
  <div>
    <!-- 媒体 -->
    <el-form-item
      label="媒体名称"
      prop="json.user_name"
    >
      <el-input
        style="width:400px"
        type="text"
        v-model="ruleForm.json.user_name"
        autocomplete="off"
        placeholder="请输入媒体名称"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="媒体级别"
      prop="json.MTlevel"
    >
      <el-select
        v-model="ruleForm.json.MTlevel"
        placeholder="请选择媒体类别"
        style="width:500px"
      >
        <el-option
          v-for="item in Mediaoptions"
          :key="item.id"
          :label="item.name"
          :value="item.name"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      label="平台类型"
      prop="json.PlatformClassifieds"
    >
      <el-select
        v-model="ruleForm.json.PlatformClassifieds"
        placeholder="请选择平台类型"
        style="width: 350px"
        @change="change"
      >
        <el-option
          v-for="item in Platformoptions"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </el-form-item>

    <!-- //e 线下线上 -->
    <el-form-item
      v-if="meetingIndex==45"
      label="线上平台"
      prop="json.meeting_mode"
    >
      <el-col :span="6">
        <el-select
          v-model="ruleForm.json.meeting_mode"
          placeholder="请选择"
        >
          <el-option
            v-for="item in meeting_ModeList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-col>
    </el-form-item>
    <el-form-item
      v-if="meetingIndex==46"
      label="请输入线下平台"
      prop="json.offline_address"
    >
      <el-col :span="11">
        <el-input
          v-model="ruleForm.json.offline_address"
          placeholder="请输入线下平台"
        ></el-input>
      </el-col>
    </el-form-item>
    <!-- //e 线下线上 -->

  </div>
</template>

<script>
export default {
  name: 'mediafirm',
  props: ['ruleForm'],
  data () {
    return {
      Mediaoptions: [],
      Platformoptions: [],
      meetingIndex: 0,
      meeting_ModeList: []
    }
  },
  created () {
    this.getMediaCategories()
    this.getPlatformCategories()
    this.getMode()
  },
  methods: {
    //获取媒体分类
    //获取媒体分类
    async getMediaCategories () {
      const { data: data } = await this.$http.post("cate/list", {
        type: 10
      })
      this.Mediaoptions = data.data
    },
    //获取平台分类
    async getPlatformCategories () {
      const { data: data } = await this.$http.post("cate/list", {
        type: 13
      })
      this.Platformoptions = data.data
    },
    change (e) {
      this.meetingIndex = e
    },
    //线上地址 
    async getMode () {
      const { data: data } = await this.$http.post('cate/list', { type: 12 })
      this.meeting_ModeList = data.data
    },
  }
}

</script>
<style lang="less" scoped>
</style>